
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "assistantinfo",
components: {Swipeout, SwipeoutItem, SwipeoutButton, XButton, XHeader},
data() {
return {
dataList: [],
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
total: 0,
seq: this.$route.query.seq,
role: this.$route.query.role,
type: this.$route.query.type,
isAdd: true
}
},
methods: {
addassistant() {
this.$router.push({name: 'assistant', query: {role: this.role, seq: this.seq, type: this.type}})
},
getInfo() {
if (this.role === 'ADMIN' || this.type === 'done' || this.type === 'closed' || this.type === 'accept') {
this.isAdd = false
}
this.dataList = []
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=0&count=20', this.header)
.then(response => {
this.dataList = [...this.dataList, ...response.data.content];
this.total = response.data.total
})
},
more() {
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=' + this.dataList.length + '&count=20', this.header)
.then(response => {
this.dataList = [...this.dataList, ...response.data.content];
this.total = response.data.total
})
},
onButtonClick(userid) {
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
role: this.role,
userid: userid.toString(),
user_type: 'EXPT',
visible: false
}, this.header).then(() => {
this.getInfo()
}).catch(error => {
this.$vux.alert.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
})
}
},
created() {
this.getInfo()
}
}



// WEBPACK FOOTER //
// ./src/components/assistantinfo/assistantinfo.vue